import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Briefcase, FileText, Rows3 } from 'lucide-react'

import { DetailList, DetailRow } from './DetailList'
import { OBJECT_HREFS, type ObjectAncestors } from './objectCrumbs'

const ROWS = [
  { kind: 'advertiser', icon: Briefcase },
  { kind: 'order', icon: FileText },
  { kind: 'lineItem', icon: Rows3 },
] as const

/**
 * Read-only list naming the objects the one on the page belongs to —
 * advertiser, order, line item — each linking to its own page. Meant to sit
 * inside a detail card. Ancestors not set (or not loaded yet) are left out,
 * and with none at all nothing is rendered.
 */
export function ObjectAncestorsList({
  ancestors,
  className,
}: {
  ancestors: ObjectAncestors
  className?: string
}) {
  const { t } = useTranslation()
  const rows = ROWS.filter(({ kind }) => ancestors[kind]?.id && ancestors[kind]?.name)
  if (rows.length === 0) return null

  return (
    <DetailList className={className}>
      {rows.map(({ kind, icon }) => {
        const ref = ancestors[kind]!
        return (
          <DetailRow key={kind} label={t(`objectTypes.${kind}`)} icon={icon}>
            <Link to={OBJECT_HREFS[kind](ref.id!)} className="font-medium hover:underline">
              {ref.name}
            </Link>
          </DetailRow>
        )
      })}
    </DetailList>
  )
}
